<template>
	<div id="app" class="position-relative">
		<router-view />
		<div
			@mousedown="startDrag"
			class="draggable-model"
			:style="{ top: `${position.y}px`, left: `${position.x}px` }"
		>
			<UploadList
				v-if="showUploadList"
				@handle-upload-list="hideUploadList"
				:showUploadList="showUploadList"
				@open-modal="openModal"
			/>
		</div>
		<addFileModal
			:index="selectedIndex"
			:addnewfile="isModalOpen"
			@close="isModalOpen = false"
		/>
	</div>
</template>
<script>
import { eventBus } from "@/utils/eventBus";
import UploadList from "../src/components/UploadList.vue";
import addFileModal from "./views/asset-bank/components/AddFile.vue";
import { startTokenExpiryWatcher, checkAccess } from "./utils/tokenCheck";
import { refreshAccessToken } from "./utils/request";

export default {
	components: {
		UploadList,
		addFileModal,
	},
	data() {
		return {
			showUploadList: false,
			selectedIndex: null,
			isModalOpen: false,
			position: { x: -10, y: 35 },
			offset: { x: 70, y: 20 },
			dragging: false,
		};
	},
	created(){
		if(checkAccess('training')){
			 refreshAccessToken();
			 startTokenExpiryWatcher();
		}
	},
	mounted() {
		console.log(eventBus);

		eventBus.$on("show-upload-list", () => {
			this.showUploadList = true;
		});
		eventBus.$on("hide-upload-list", () => {
			this.showUploadList = false;
		});
		eventBus.$on("hide-add-modal", () => {
			this.isModalOpen = false;
		});
	},
	beforeDestroy() {
		eventBus.$off("show-upload-list");
		eventBus.$off("hide-upload-list");
		eventBus.$off("hide-add-modal");
	},
	methods: {
		startDrag(event) {
			this.dragging = true;
			this.offset.x = event.clientX - this.position.x;
			this.offset.y = event.clientY - this.position.y;
			document.addEventListener("mousemove", this.onDrag);
			document.addEventListener("mouseup", this.stopDrag);
		},
		onDrag(event) {
			if (this.dragging) {
				this.position.x = event.clientX - this.offset.x;
				this.position.y = event.clientY - this.offset.y;
			}
		},
		stopDrag() {
			this.dragging = false;
			document.removeEventListener("mousemove", this.onDrag);
			document.removeEventListener("mouseup", this.stopDrag);
		},
		openModal(index) {
			this.selectedIndex = index;
			this.isModalOpen = true;
		},
		hideUploadList() {
			this.showUploadList = false;
		},
	},
};
</script>
<style>
.draggable-model {
	position: relative;

	cursor: grab;
	user-select: none;
}
.draggable-model:active {
	cursor: grabbing;
}
</style>
